import { Record, Union } from "../fable_modules/fable-library-js.4.19.0/Types.js";
import { record_type, lambda_type, unit_type, union_type, option_type, class_type } from "../fable_modules/fable-library-js.4.19.0/Reflection.js";
import { Msg, GlobalMsg, GlobalMessageBox_Error_Z721C83C5, Msg_$reflection, Model_$reflection } from "../../Bfs.Web.Portale/Types.fs.js";
import { FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E } from "../fable_modules/Fable.React.9.4.0/./Fable.React.FunctionComponent.fs.js";
import { value as value_4 } from "../fable_modules/fable-library-js.4.19.0/Option.js";
import { stringHash, int32ToString } from "../fable_modules/fable-library-js.4.19.0/Util.js";
import * as react from "react";
import * as PwaScripts from "./PwaScripts.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/./Interop.fs.js";
import * as NotificationScripts from "./NotificationScripts.js";
import { useEffectOnce } from "../fable_modules/Feliz.2.9.0/./Internal.fs.js";
import { fetch$ } from "../fable_modules/Fable.Fetch.2.7.0/Fetch.fs.js";
import { contains, empty } from "../fable_modules/fable-library-js.4.19.0/List.js";
import { empty as empty_1, singleton, append, delay } from "../fable_modules/fable-library-js.4.19.0/Seq.js";
import { icon } from "../../Bfs.Web.Portale/ViewParts.fs.js";
import { NotificationHelper_SubscribeToWebPush, NotificationPermissionGranted } from "./NotificationBindings.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.3.2.0/PromiseImpl.fs.js";

export class PwaStatus extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Unknown", "Installable", "InstalledRecently", "Installed"];
    }
}

export function PwaStatus_$reflection() {
    return union_type("Bfs.Web.Kundenportal.Pwa.PwaStatus", [], PwaStatus, () => [[], [["Item", option_type(class_type("Browser.Types.Event", undefined))]], [], []]);
}

export class BannerModel extends Record {
    constructor(Model, Dispatch) {
        super();
        this.Model = Model;
        this.Dispatch = Dispatch;
    }
}

export function BannerModel_$reflection() {
    return record_type("Bfs.Web.Kundenportal.Pwa.BannerModel", [], BannerModel, () => [["Model", Model_$reflection()], ["Dispatch", lambda_type(Msg_$reflection(), unit_type)]]);
}

export const Banner = FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E((((value_4("C:\\BuildAgent\\work\\c238671ccc1e7da2\\BfsKundenportal\\src\\Bfs.Web.Kundenportal\\PWA\\Pwa.fs") + "#L") + int32ToString(value_4(32))) + ";") + "Bfs.Web.Kundenportal.Pwa.BannerModel", value_4("Banner"), (param) => {
    let matchValue, matchValue_1;
    const pwaStatus = react.useState((matchValue = PwaScripts.isRunningAsPwa(), (matchValue_1 = PwaScripts.isOnIos(), matchValue ? (new PwaStatus(3, [])) : (matchValue_1 ? (new PwaStatus(1, [undefined])) : (new PwaStatus(0, []))))));
    const installerHidden = react.useState(false);
    const patternInput = reactApi.useState(false);
    const setShowInstallHint = patternInput[1];
    const installHintClass = patternInput[0] ? "active" : "";
    const notificationBannerHidden = react.useState(false);
    const notificationPermissions = react.useState(NotificationScripts.notificationPermission());
    const subscribing = react.useState(false);
    const subscribingClass = (subscribing[0]) ? "is-loading" : "";
    useEffectOnce(() => {
        window.addEventListener("beforeinstallprompt", (ev) => {
            ev.preventDefault();
            pwaStatus[1](new PwaStatus(1, [ev]));
        });
    });
    useEffectOnce(() => {
        window.addEventListener("appinstalled", (_arg_2) => {
            pwaStatus[1](new PwaStatus(2, []));
        });
    });
    const dependencies = [param.Model.User];
    reactApi.useEffect(() => {
        let pr;
        if ((param.Model.User != null) && PwaScripts.isRunningAsPwa()) {
            (pr = fetch$("/api/account/updatePwaStarted", empty()), pr.then((_arg_4) => {
            }));
        }
    }, dependencies);
    return Array.from(delay(() => {
        let matchValue_3, matchValue_4, matchValue_5, matchValue_6, user_1, children_16, children_14, children_2, children_8, children_12;
        return append(singleton((matchValue_3 = param.Model.User, (matchValue_4 = (installerHidden[0]), (matchValue_5 = (pwaStatus[0]), (matchValue_6 = (isTouch), (matchValue_3 != null) ? (matchValue_4 ? react.createElement(react.Fragment, {}) : (matchValue_6 ? ((matchValue_5.tag === 3) ? react.createElement(react.Fragment, {}) : ((matchValue_5.tag === 2) ? react.createElement(react.Fragment, {}) : ((matchValue_5.tag === 1) ? (!contains("KundeMitPwa", matchValue_3.Roles, {
            Equals: (x, y) => (x === y),
            GetHashCode: stringHash,
        }) ? ((user_1 = matchValue_3, react.createElement(react.Fragment, {}))) : ((children_16 = [(children_14 = [(children_2 = [icon("fal fa-times fa-2x has-text-white")], react.createElement("a", {
            className: "cancel-icon",
            onClick: (_arg_5) => {
                installerHidden[1](true);
            },
        }, ...children_2)), react.createElement("img", {
            className: "logo",
            src: "BfsLogoWhite.svg",
        }), (children_8 = [react.createElement("b", {}, "BFS Kundenportal"), react.createElement("div", {
            className: "pwa-subtitle",
        }, "Jetzt die App installieren!")], react.createElement("div", {
            className: "name",
        }, ...children_8)), (children_12 = [react.createElement("button", {
            className: "button is-white is-outlined is-rounded has-text-white",
            onClick: (_arg_6) => {
                let arg;
                if (matchValue_5.fields[0] == null) {
                    setShowInstallHint(true);
                }
                else {
                    (arg = matchValue_5.fields[0], PwaScripts.promptInstall(arg));
                }
            },
        }, "Installieren")], react.createElement("div", {
            className: "install",
        }, ...children_12))], react.createElement("div", {
            className: "pwa-installer",
        }, ...children_14))], react.createElement("div", {
            className: "pwa-banner",
        }, ...children_16)))) : react.createElement(react.Fragment, {})))) : react.createElement(react.Fragment, {}))) : react.createElement(react.Fragment, {})))))), delay(() => {
            let children_32, children_30, children_18, children_24, children_28;
            return append(((((param.Model.User != null) && PwaScripts.isRunningAsPwa()) && (NotificationScripts.notificationPermission() === "default")) && !(notificationBannerHidden[0])) ? singleton((children_32 = [(children_30 = [(children_18 = [icon("fal fa-times fa-2x has-text-white")], react.createElement("a", {
                className: "cancel-icon",
                onClick: (_arg_7) => {
                    notificationBannerHidden[1](true);
                },
            }, ...children_18)), (children_24 = [react.createElement("b", {}, "Pushnachrichten"), react.createElement("div", {
                className: "pwa-subtitle",
            }, "Aktivieren Sie jetzt Pushnachrichten um immer auf dem aktuellen Stand zu sein!")], react.createElement("div", {
                className: "name",
            }, ...children_24)), (children_28 = [react.createElement("button", {
                className: `button is-white is-outlined is-rounded has-text-white ${subscribingClass}`,
                onClick: (_arg_8) => {
                    subscribing[1](true);
                    let pr_4;
                    const pr_3 = NotificationScripts.requestNotificationPermission();
                    pr_4 = (pr_3.then((permissions) => {
                        if (permissions === NotificationPermissionGranted) {
                            let pr_2;
                            const pr_1 = NotificationHelper_SubscribeToWebPush();
                            pr_2 = (pr_1.then((success) => {
                                notificationPermissions[1](permissions);
                            }));
                            return pr_2.catch((ex) => {
                                param.Dispatch(new Msg(0, [new GlobalMsg(3, [GlobalMessageBox_Error_Z721C83C5("Die Pushnachrichten konnten leider nicht aktiviert werden. Bitte wechseln Sie in die Benachrichtigungseinstellungen und versuchen Sie es erneut.")])]));
                            });
                        }
                        else {
                            return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(notificationPermissions[1](permissions)))));
                        }
                    }));
                    void (pr_4.then(() => {
                        subscribing[1](false);
                    }));
                },
            }, "Aktivieren")], react.createElement("div", {
                className: "install",
            }, ...children_28))], react.createElement("div", {
                className: "pwa-installer pwa-notfications",
            }, ...children_30))], react.createElement("div", {
                className: "pwa-banner",
            }, ...children_32))) : empty_1(), delay(() => {
                let children_52, children_50, children_38, children_48, children_46, children_42, children_44;
                return singleton((children_52 = [react.createElement("div", {
                    className: "pwa-install-hint-backdrop",
                    onClick: (_arg_10) => {
                        setShowInstallHint(false);
                    },
                }), (children_50 = [(children_38 = [react.createElement("img", {
                    className: "logo",
                    src: "BfsLogo.svg",
                }), react.createElement("b", {}, "BFS Kundenportal installieren")], react.createElement("div", {
                    className: "pwa-install-hint-header",
                }, ...children_38)), react.createElement("hr", {}), (children_48 = [react.createElement("p", {}, "Installieren Sie die BFS Kundenportal App in zwei einfachen Schritten:"), (children_46 = [(children_42 = ["Tippen Sie auf das Share-Icon in Ihrem Browser", icon("fal fa-arrow-square-up")], react.createElement("li", {}, ...children_42)), (children_44 = ["Wählen Sie \"Zum Startbildschirm hinzufügen\"", icon("fal fa-plus-square")], react.createElement("li", {}, ...children_44))], react.createElement("ol", {}, ...children_46))], react.createElement("div", {
                    className: "pwa-install-hint-body",
                }, ...children_48))], react.createElement("div", {
                    className: "pwa-install-hint-content",
                }, ...children_50))], react.createElement("div", {
                    className: `pwa-install-hint ${installHintClass}`,
                }, ...children_52)));
            }));
        }));
    }));
}, undefined, undefined, "Of");

//# sourceMappingURL=Pwa.fs.js.map
